export const recoverPasswordTypes = {
    RECOVER_EMAIL: 'RECOVER_EMAIL',
    RECOVER_EMAIL_LOADER: 'RECOVER_EMAIL_LOADER',
    RECOVER_EMAIL_SUCCESS: 'RECOVER_EMAIL_SUCCESS',
    RECOVER_EMAIL_FAILURE: 'RECOVER_EMAIL_FAILURE',
    RESET_PASSWORD_DETAILS: 'RESET_PASSWORD_DETAILS',
    RESET_PASSWORD_LOADER: 'RESET_PASSWORD_LOADER',
    RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
    RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',
}